<template>
  <b-overlay
    id="overlay-background"
    :show="ApiSettingloader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="12"
        lg="12"
        class="fields-container"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <validation-observer ref="refEmailFormObserver">
              <!-- form -->
              <b-form>
                <b-col
                  v-for="statement_setting_value in statement_setting_values"
                  :key="statement_setting_value.id"
                  cols="12"
                >
                  <b-row>
                    <b-col sm="2">
                      <validation-provider
                        #default="{ errors }"
                        name="key"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_KEY')"
                          label-for="key"
                        >
                          <b-form-input
                            id="key"
                            v-model="statement_setting_value.key"
                            :state="errors.length > 0 ? false : null"
                            type="text"
                            :placeholder="$t('DEBTIA_KEY')"
                            trim
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col sm="4">
                      <validation-provider
                        #default="{ errors }"
                        name="en_name"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_EN_TITLE')"
                          label-for="en-name"
                        >
                          <b-form-input
                            id="en-name"
                            v-model="statement_setting_value.en_name"
                            :state="errors.length > 0 ? false : null"
                            type="text"
                            :placeholder="$t('DEBTIA_EN_NAME')"
                            trim
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col sm="4">
                      <validation-provider
                        #default="{ errors }"
                        name="da_name"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_DA_TITLE')"
                          label-for="da-name"
                        >
                          <b-form-input
                            id="da-name"
                            v-model="statement_setting_value.da_name"
                            :state="errors.length > 0 ? false : null"
                            type="text"
                            :placeholder="$t('DEBTIA_DA_NAME')"
                            trim
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col sm="2">
                      <validation-provider
                        #default="{ errors }"
                        name="Status"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_STATUS')"
                          label-for="status"
                        >
                          <b-form-checkbox
                            v-model="statement_setting_value.status"
                            class="mr-0 mt-50"
                            name="is-rtl"
                            switch
                            inline
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-col>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="postStatementSettingValues"
                >
                  Save
                </b-button>
              </b-form>
              <!--/ form -->
            </validation-observer>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BFormInput, BOverlay, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
// import i18n from '@/libs/i18n'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BOverlay,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      ApiSettingloader: false,
      required,
      communication_client_id: '',
      communication_secret: '',
      statement_setting_values: [],
    }
  },
  watch: {
    settings: {
      handler() {
        this.mapValues()
      },
    },
  },

  methods: {
    mapValues() {
      this.statement_setting_values = this.settings
    },
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.ApiSettingloader = false
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
    postStatementSettingValues() {
      axios.post('settings/save-statement-settings', this.statement_setting_values).then(response => {
        if (response.status) {
          this.statement_setting_values = [...response.data.data]
          this.makeSuccessToast()
        }
      }).catch(error => {
        this.makeFailureToast(error)
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
